import { createListenerMiddleware, addListener } from "@reduxjs/toolkit";
import { TypedStartListening, TypedAddListener } from "@reduxjs/toolkit";

import { RootState, AppDispatch } from "./Store";

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<
  RootState,
  AppDispatch
>;
